"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowAllVendors = void 0;
var _constants = require("../constants");
const shouldShowAllVendors = () => Boolean(window.localStorage) && Boolean(JSON.parse(localStorage.getItem(_constants.SHOW_ALL_VENDORS_KEY) ?? '0'));
exports.shouldShowAllVendors = shouldShowAllVendors;